import Vue from 'vue'
import Login from './index.vue'

let newInstance = null

//将vue组件变为构造函数
let LoginConstructor = Vue.extend(Login)

let init = (options)=>{
    //实例化组件
    newInstance = new LoginConstructor()
   //合并配置选项
    Object.assign(newInstance,options)
   //使用$mount()后  可以理解为创建虚拟的dom
    document.body.appendChild(newInstance.$mount().$el)
}
let login = (options)=>{
    //options 为调用组件方法时传入的配置选项
    if(!newInstance){
        init(options)
    }
    newInstance.successCallback = options.callback;
    newInstance.params.mobile = options.userPhone;
    return newInstance.show(() =>{newInstance = null})
}
export default login